import BackButton from '../../components/BackButton/BackButton.jsx';
import Styles from './Privacy.module.css';

const Privacy = () => {
  return (
    <div>
      <BackButton />
      <div className={Styles.privacyContainer}>
        <h1>Brassflows Privacy Policy</h1>
        <p>
          Brassflows ("we”, “us”, or “our") operates the website brassflows.com
          (the "Site"). This Privacy Policy explains how we collect, use, and
          protect your personal information when you use our Site. By using
          Brassflows, you agree to the terms of this Privacy Policy.
        </p>
        <h2>1. Information We Collect</h2>
        <p>
          We only collect the following personal information: Email address and
          Password. We do not collect: Cookies or tracking technologies. IP
          addresses or device identifiers (unless automatically logged by our
          hosting provider for security purposes). Any other personal data
          beyond what’s necessary for account creation.
        </p>
        <h2>2. How We Use Your Information</h2>
        <p>
          Your data is used solely to: Create and maintain your account.
          Authenticate logins. Send service-related emails (e.g., password
          resets). We do not: Sell, rent, or trade your data. Use your data for
          marketing or advertising. Share your data with third parties, except
          as required by law (see Section 4).
        </p>
        <h2>3. Data Security</h2>
        <p>
          We take reasonable measures to protect your information. HTTPS
          (SSL/TLS) encrypts data in transit. Regular security reviews of our
          systems. However, no method is 100% secure—please use a strong, unique
          password.
        </p>
        <h2>4. Information Disclosure</h2>
        <p>
          We may disclose your information only if: Required by law (e.g.,
          subpoena, court order). Necessary to protect our rights, safety, or
          property (e.g., fraud prevention). We do not share data with
          advertisers, analytics tools, or other third-party services.
        </p>
        <h2>5. Account Deletion</h2>
        <p>
          You may request deletion of your account by contacting us at
          support@brassflows.com. Upon deletion: Your email and account data
          will be permanently erased from our systems. No backups or residual
          data will be retained.
        </p>
        <h2>6. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy occasionally. Changes take effect
          immediately upon posting. Continued use of Brassflows after updates
          constitutes acceptance.
        </p>
        <h2>7. Contact Us</h2>
        <p>
          For questions or requests about your data, contact: Email:
          support@brassflows.com
        </p>
      </div>
    </div>
  );
};

export default Privacy;
